import React from 'react'
import {
  Container, Row, Col,
} from 'reactstrap'
import {FaMapMarkerAlt} from 'react-icons/fa'
import {ThemeProvider} from 'styled-components'

// Components
import Details from './details.styled'
import Slider from '~/components/Slider'
import {M2} from '~/components/ProductCard/ProductCard.styled'
import ProductList from '~/components/ProductList'
import SEO from '~/components/SEO'
import AdvancedSearch from '~/pagesContent/home/AdvancedSearch'

// Utils
import {
  renderHtml, convertMoney,
} from '~/utils'

// Constants
import {colors} from '~/constants/style'

const DetailsPage = (props) => {
  const {
    product,
    relatedProducts,
    fullUrl,
    address,
    youtubeVideoId,
    token,
    handleUpProduct,
  } = props

  const {
    isSold,
    thumbnail = {},
    gallery,
    name = '',
    seo: {
      metaDesc,
      metaKeywords,
    },
    categories = [],
    directions = [],
    price,
    brief = {},
    description = {},
    area,
    numberOfBedrooms,
    numberOfBathrooms,
  } = product

  return (
    <>
      <SEO
        title={name}
        keywords={metaKeywords}
        description={metaDesc}
        thumbnail={thumbnail}
        url={fullUrl}
      />

      {!!token && (
        <Details.AdminZone>
          <Details.UpBtn onClick={handleUpProduct}>Up tin này</Details.UpBtn>

          <Details.EditBtn href={`https://khanhpv.xyz/wp-admin/post.php?post=${product.databaseId}&action=edit`} />
        </Details.AdminZone>
      )}

      <Details>
        <Container fluid>
          <Row>
            <Col md={6}>
              <Details.Slider>
                <Slider images={gallery} />
              </Details.Slider>
            </Col>

            <Col md={6}>
              <Details.Brief>

                <Details.Name>{name}</Details.Name>

                <>
                  <Details.BriefTopItemsWrapper>
                    <Details.BriefTopItem>
                      <FaMapMarkerAlt />
                      {` ${address}`}
                    </Details.BriefTopItem>

                    {!!(categories && categories.length) && (
                      <Details.BriefTopItem>
                        <FaMapMarkerAlt />
                        {` ${categories.map((category) => category.name).join(', ')}`}
                      </Details.BriefTopItem>
                    )}

                    {!!(directions && directions.length) && (
                      <Details.BriefTopItem>
                        <FaMapMarkerAlt />
                        {' Hướng '}
                        {directions.map((direction) => direction.name).join(', ')}
                      </Details.BriefTopItem>
                    )}
                  </Details.BriefTopItemsWrapper>

                  <Details.Price>
                    {convertMoney(+price)}
                    {' VND'}
                    {isSold && <span style={{color: colors.red}}> - Đã bán</span>}
                  </Details.Price>

                  <Details.BriefContent>{renderHtml(brief)}</Details.BriefContent>

                  <Details.BriefBottomItemsWrapper>
                    <Details.BriefBottomItem>
                      {'Diện tích: '}
                      <span>
                        {`${area} `}
                        <M2 />
                      </span>
                    </Details.BriefBottomItem>

                    <Details.BriefBottomItem>
                      {'Phòng ngủ: '}
                      <span>{numberOfBedrooms || 'N/A'}</span>
                    </Details.BriefBottomItem>

                    <Details.BriefBottomItem>
                      {'Phòng tắm: '}
                      <span>{numberOfBathrooms || 'N/A'}</span>
                    </Details.BriefBottomItem>
                  </Details.BriefBottomItemsWrapper>
                </>
              </Details.Brief>
            </Col>
          </Row>
        </Container>

        <Details.Main>
          <Row>
            <Col md={9}>
              <Details.Section>
                <Details.SectionTitle>Thông tin mô tả</Details.SectionTitle>

                <Details.Description>
                  {renderHtml(description)}
                </Details.Description>
              </Details.Section>

              {!!youtubeVideoId && (
                <Details.Section>
                  <Details.SectionTitle>Video mô tả</Details.SectionTitle>

                  <Details.Youtube videoId={youtubeVideoId} />
                </Details.Section>
              )}
            </Col>

            <Col md={3}>
              <Details.Section>
                <Details.SectionTitle>Tìm kiếm</Details.SectionTitle>

                <ThemeProvider
                  theme={{
                    oneColumnLayout: true,
                    noBg: true,
                  }}
                >
                  <AdvancedSearch />
                </ThemeProvider>
              </Details.Section>
            </Col>

            <Col xs={12}>
              <Details.Section className='mb-0'>
                <Details.SectionTitle>
                  {'Bất động sản '}
                  <span className='green'>liên quan</span>
                </Details.SectionTitle>

                <ProductList list={relatedProducts} />
              </Details.Section>
            </Col>
          </Row>
        </Details.Main>
      </Details>
    </>
  )
}

export default DetailsPage
